import config from '../../config';

import editGroupHeaderUrl from './editGroupHeader.html';

class EditGroupHeaderController {
  DELETING_PERSONAS_ENABLED = config.DELETING_PERSONAS_ENABLED;

  constructor(PersonaCollection, UserUtils, $rootScope, $state, $window, uppercaseFirstFilter) {
    'ngInject';

    Object.assign(this, { PersonaCollection, UserUtils, $state, $window, uppercaseFirstFilter });
    this.navbarHeight = $rootScope.navbarHeight;
  }

  $onInit() {
    this._setEditableGroups();
  }

  get canArchive() {
    return (
      config.ARCHIVING_LOCATIONS_POSITIONS_ENABLED &&
      ['location', 'position'].includes(this.group.type)
    );
  }

  getMainRouteName() {
    return `${this.uppercaseFirstFilter(this.group.type)}s`;
  }

  getTitle() {
    if (this.title) {
      return this.title;
    }

    return `Add ${this.group.type}`;
  }

  getGroupListSref() {
    return this.listSref || `dashboard.manage.${this.srefType || this.group.type}s.list`;
  }

  getGroupsSref() {
    if (this.previousState?.name) {
      const serializedObject = Object.keys(this.previousState.params)
        .filter((key) => !!this.previousState.params[key])
        .map((key) => `${key}: '${this.previousState.params[key]}'`)
        .join(',');

      return `${this.previousState.name}({${serializedObject}})`;
    }

    return this.listSref || `dashboard.manage.${this.group.type}s.list`;
  }

  navigateToAnother(groupId) {
    const params = {
      groupId,
      tab: this.tab,
    };

    this.$state.go(`dashboard.manage.${this.group.type}s.edit`, params);
  }

  _setEditableGroups() {
    const groupTypePlural = `${this.group.type}s`;
    const groups = this.PersonaCollection[groupTypePlural];
    if (groups) {
      this.editableGroups = groups.filter((group) => this.UserUtils.canEditGroup(group));
    }
  }
}

export default {
  controller: EditGroupHeaderController,
  controllerAs: 'ctrl',
  templateUrl: editGroupHeaderUrl,
  bindings: {
    group: '<',
    previousState: '<',
    listSref: '@',
    deleteGroup: '&',
    archiveGroup: '&',
    nextGroupId: '<',
    previousGroupId: '<',
    tab: '<',
    title: '@?',
  },
};
